import { render, staticRenderFns } from "./communicationgroup.vue?vue&type=template&id=437f7877&scoped=true&"
import script from "./communicationgroup.vue?vue&type=script&lang=js&"
export * from "./communicationgroup.vue?vue&type=script&lang=js&"
import style0 from "./communicationgroup.vue?vue&type=style&index=0&id=437f7877&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f7877",
  null
  
)

export default component.exports